import { useEffect, useMemo, useRef, useState } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { selectCurrentUser } from "src/modules/users/selector";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";

import SortIcon from "../ui-icons/table/SortIcon";
import { twMerge } from "tailwind-merge";
import { Bell } from "../ui-icons/myTasks/bell";
import { isStrapi } from "src/api/config/systemSwitch";

const ActionsMainPageTable = (props: any) => {
  const { data, custom, showBell = true } = props;
  const [sortData, setSortData] = useState<any>([]);
  const [query, setQuery] = useSearchParams();
  const [tableHeaderContent, setTableHeaderContent] = useState<any>({
    Created: {
      title: "Дата создания",
      sort: true,
      style: { width: "w-2/12" },
      sortDirection: "default",
      sortType: "date",
    },
    Description: {
      title: "Описание",
      sort: true,
      style: { width: "w-6/12" },
      sortDirection: "default",
      sortType: "string",
    },
    DateForDone: {
      title: "Срок выполнения",
      sort: true,
      style: { width: "w-2/12" },
      sortDirection: "default",
      sortType: "date",
    },
    Status: {
      title: "Статус",
      sort: false,
      style: { width: "w-2/12" },
      sortDirection: "default",
      sortType: "string",
    },
  });
  const currentUser: any = useAppSelector(selectCurrentUser);

  console.log('sortData', custom)

  const openDocumentCard = (id: number) => {
    const newSearchParams = new URLSearchParams(query);
    newSearchParams.set("actionCardMobile", id.toString());
    setQuery(newSearchParams);
  };

  const sortDataHandle = (sortField: string, sortDirection: string, sortType: string) => {
    const tempTableHeaderContent = { ...tableHeaderContent };
    const tempData = [...data];
    Object.keys(tempTableHeaderContent).map((key: string) => {
      tempTableHeaderContent[key]["sortDirection"] = "default";
    });
    if (sortDirection === "default") {
      tempTableHeaderContent[sortField]["sortDirection"] = "desc";
    }
    if (sortDirection === "desc") {
      tempTableHeaderContent[sortField]["sortDirection"] = "asc";
    }
    if (sortDirection === "asc") {
      tempTableHeaderContent[sortField]["sortDirection"] = "default";
      setSortData([...data]);
    }
    if (sortType === "number") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        tempData.sort((a: any, b: any) => parseFloat(a[sortField]) - parseFloat(b[sortField]));
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        tempData.sort((a: any, b: any) => parseFloat(b[sortField]) - parseFloat(a[sortField]));
      }
    }
    if (sortType === "string") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        tempData.sort((a: any, b: any) => {
          return a[sortField].localeCompare(b[sortField]);
        });
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        tempData.sort((a: any, b: any) => {
          return b[sortField].localeCompare(a[sortField]);
        });
      }
    }
    if (sortType === "date") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        const distantFuture = new Date(8640000000000000);
        tempData.sort((a: any, b: any) => {
          let dateA = a[sortField] || distantFuture;
          let dateB = b[sortField] || distantFuture;
          return dateA.getTime() - dateB.getTime();
        });
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        const distantFuture = new Date(8640000000000000);
        tempData.sort((a: any, b: any) => {
          let dateA = a[sortField] || distantFuture;
          let dateB = b[sortField] || distantFuture;
          return dateB.getTime() - dateA.getTime();
        });
      }
    }
    setTableHeaderContent({ ...tempTableHeaderContent });
    setSortData([...tempData]);
  };

  useEffect(() => {
    const sortedByCreatedDesc = [...data].sort((a: any, b: any) => {
      const aDate = a?.Created ? new Date(a.Created).getTime() : 0;
      const bDate = b?.Created ? new Date(b.Created).getTime() : 0;
      return bDate - aDate; // новые выше
    });
    setSortData(sortedByCreatedDesc);
    const tempTableHeaderContent = { ...tableHeaderContent };
    Object.keys(tempTableHeaderContent).map((key: string) => {
      tempTableHeaderContent[key]["sortDirection"] = "default";
    });
    setTableHeaderContent({ ...tempTableHeaderContent });
  }, [data]);

  return (
    <FlexCol className="w-full">
      <FlexCol className="relative">
        <FlexCol
          id="actions_main_page"
          className="relative overflow-x-auto bg-white rounded-lg table-custom shadow-custom no-scrollbar md:scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-265px)] max-h-[calc(100dvh-265px)] min-h-[60px]"
        >
          <FlexRow className="w-full pb-5 sticky-custom max-h-[65px] bg-white pt-5 px-10 z-10 hidden">
            {Object.keys(tableHeaderContent).map((fieldKey) => {
              const key: string = fieldKey;
              return (
                <TableHeaderColumn
                  key={fieldKey}
                  sortField={fieldKey}
                  tableHeaderContent={tableHeaderContent[key]}
                  sortDataHandle={sortDataHandle}
                />
              );
            })}
          </FlexRow>
          <FlexCol className="w-full  divide-y grow">
            {(sortData.length > 0 &&
              sortData.map((item: any) => (
                <FlexRow
                  className="w-full py-4 pl-[34px] pr-[16px] cursor-pointer flex-col"
                  key={item.ID}
                  onClick={() => openDocumentCard(item.ID)}
                >
                  <FlexRow className="relative break-words items-center text-[#637381] w-full">
                    {showBell && !item.View && (
                      <FlexCol className="absolute right-0 top-0">
                        <Bell />
                      </FlexCol>
                    )}
                    <span className="block text-sm font-normal not-italic text-[#637381] hidden">
                      {moment(item.Created).format("DD.MM.YYYY")}
                    </span>
                  </FlexRow>
                  <FlexCol className="break-words text-[#012169] w-full flex-row items-start gap-[8px] pr-[13px] relative">
                    {item.Description && (
                      <>
                        <div className="min-w-[10px] min-h-[10px] absolute left-[-18px]">
                          <svg className="mt-[5px]" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <circle cx="5" cy="5" r="5" fill={isStrapi ? custom ? item.Status.Metadata.Color : item.Status.get_metadata().Color : custom ? item.Status_x003a_Color.Title : item.Status_x003a_Color.get_lookupValue()} />
                          </svg>
                        </div>
                        <div
                          className="line-clamp-2"
                          dangerouslySetInnerHTML={{
                            __html: item.Description.replace(
                              /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                              '<span style="color: rgb(0,98,155)">$&</span>'
                            ),
                          }}
                        />
                      </>
                    )}
                  </FlexCol>
                  <FlexCol className="break-words text-[#637381] w-full mt-[8px]">
                    <span className="block font-normal not-italic text-[#637381] text-[13px]">
                        Срок&nbsp;
                      {moment(item.DateForDone).format("DD.MM.YYYY")}
                    </span>
                  </FlexCol>
                  <FlexCol className="break-words text-[#637381] w-full hidden">
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <circle cx="5" cy="5" r="5" fill={isStrapi ? custom ? item.Status.Metadata.Color : item.Status.get_metadata().Color : custom ? item.Status_x003a_Color.Title : item.Status_x003a_Color.get_lookupValue()} />
                      </svg>
                      &nbsp;&nbsp;{custom ? item.Status.Title : item.Status.get_lookupValue()}
                    </div>
                  </FlexCol>
                </FlexRow>
              ))) || (
              <FlexCol className="items-center justify-center w-full mt-5 mb-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M15.8266 11.1376H8.17656C7.72656 11.1376 7.35156 11.5126 7.35156 12.0001C7.35156 12.4501 7.72656 12.8251 8.21406 12.8251H15.8641C16.3141 12.8251 16.6891 12.4501 16.6891 11.9626C16.6516 11.5126 16.2766 11.1376 15.8266 11.1376Z"
                    fill="#637381"
                  />
                  <path
                    d="M12.0008 0.675049C5.73828 0.675049 0.675781 5.73755 0.675781 12C0.675781 18.2626 5.77578 23.3625 12.0383 23.3625C18.3008 23.3625 23.4008 18.2626 23.4008 12C23.3633 5.73755 18.2633 0.675049 12.0008 0.675049ZM12.0008 21.675C6.67578 21.675 2.36328 17.325 2.36328 12C2.36328 6.67505 6.67578 2.36255 12.0008 2.36255C17.3258 2.36255 21.6758 6.71255 21.6758 12.0375C21.6758 17.325 17.3258 21.675 12.0008 21.675Z"
                    fill="#637381"
                  />
                </svg>
                <p>Нет открытых действий</p>
              </FlexCol>
            )}
          </FlexCol>
        </FlexCol>
      </FlexCol>
    </FlexCol>
  );
};

export default ActionsMainPageTable;

export function TableHeaderColumn({ tableHeaderContent, sortDataHandle, sortField }: any) {
  return (
    <FlexCol className={twMerge("select-none", tableHeaderContent.style.width)}>
      <FlexRow>
        {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
        <FlexCol className="font-medium whitespace-pre-line">{tableHeaderContent.title}</FlexCol>
        {tableHeaderContent.sort && (
          <FlexCol
            className="w-auto cursor-pointer"
            onClick={() => sortDataHandle(sortField, tableHeaderContent.sortDirection, tableHeaderContent.sortType)}
          >
            <SortIcon sortDirection={tableHeaderContent.sortDirection} />
          </FlexCol>
        )}
      </FlexRow>
    </FlexCol>
  );
}
